<template>
    <div class="newstartdate">
  
      <h1>Förändring pris/datum</h1>
      <form @submit.prevent="submit">

        <!--<div style="padding-top:20px;">
            <strong>Nytt startdatum: {{$root.calculateNewContractDate()}}</strong>
        </dv>-->

        <p>
          {{$root.newStartDate_message}}
        </p>

        <label class="checkbox">
        <input type="checkbox" class="checkbox__field" required v-model="$root.terms_newstartdate">
        <span class="checkbox__label">Jag förstår att utifrån mina val så behöver mitt startdatum ändras.</span>
        </label>

       <div class="step-nav" v-bind:class="{disabled : !$root.terms_newstartdate }">
            <button type="submit" class="button button--with-icon step-nav__button">Fortsätt <Arrow /></button>
       </div>
      </form>

    </div>
  </template>
  <script>
  
  export default {
      mounted() {
        this.$root.newStartDate_message = '';
        console.log ("NewStartDate");
        document.getElementsByClassName('newstartdate')[0].scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});

        let curThis = this;

        if (this.$root.contract.date >= this.$root.calculateNewContractDate() && this.$root.contract.date == this.$root.searchStartDate) {
            //this.$router.push({ name: 'ordersummary' })
            this.$root.detailsShow = 'ordersummary';
            this.$root.flowString = this.$root.flowString.replace('newstartdate', '');
        } else {
          // Date is changed, check new price?
          // if (this.$root.price_type != 'spotavtal') {
          //    this.$root.calculateNewContractDate_message = 'Vid byte från timavtal så kan ditt nya elavtal starta den 1:e i nästkommande månad.';
          // }

          // Kolla här om det nya datumet ger en prisförändring? I så fall säg det också i meddelandet!

          let currentDate = this.$root.contract.date;

          if (this.$root.price_type == 'fixed') {
            let currentPrice = this.$root.getTotalFixedPrice(this.$root.watts, true);

            this.$root.searchStartDate = this.$root.calculateNewContractDate();
            this.$root.newStartDate_message = this.$root.calculateNewContractDate_message;

            this.$root.contract.date = this.$root.searchStartDate;

            let loadedPriceTypes = [];

            this.$root.loadContracts(function (loadedPriceType) {
              //alert ("Price type" + loadedPriceType + " is loaded!");

              loadedPriceTypes.push(loadedPriceType);

              if (loadedPriceTypes.includes('movable') && loadedPriceTypes.includes('fixed')) {
                let newPrice = curThis.$root.getTotalFixedPrice(curThis.$root.watts, true);
                let newDate = curThis.$root.contract.date;

                console.log ("price: " + currentPrice + " vs " + newPrice);
                if (currentPrice != newPrice) {
                  curThis.$root.newStartDate_message = 'Med nya datumet ' + newDate + ' så har du fått ett nytt pris som är ' + newPrice + ' öre/kWh inkl.moms';

                  curThis.$root.searchStartDate = currentDate;
                  curThis.$root.contract.date = curThis.$root.searchStartDate;
                  curThis.$root.loadContracts();

                } else {
                  curThis.$root.detailsShow = 'ordersummary';
                  curThis.$root.flowString = this.$root.flowString.replace('newstartdate', '');

                }

              }

            });

          } else if (this.$root.price_type == 'mix5050') {
            let currentPrice = this.$root.getTotalMix5050Price(this.$root.watts);

            this.$root.searchStartDate = this.$root.calculateNewContractDate();
            this.$root.newStartDate_message = this.$root.calculateNewContractDate_message;

            this.$root.contract.date = this.$root.searchStartDate;

            let loadedPriceTypes = [];

            this.$root.loadContracts(function (loadedPriceType) {

              loadedPriceTypes.push(loadedPriceType);

              if (loadedPriceTypes.includes('movable') && loadedPriceTypes.includes('fixed')) {

                let newPrice = curThis.$root.getTotalMix5050Price(curThis.$root.watts);
                let newDate = curThis.$root.contract.date;

                console.log ("price: " + currentPrice + " vs " + newPrice);
                if (currentPrice != newPrice) {
                  curThis.$root.newStartDate_message = 'Med nya datumet ' + newDate + ' så har du fått ett nytt pris som är ' + newPrice + ' öre/kWh inkl.moms';

                  curThis.$root.searchStartDate = currentDate;
                  curThis.$root.contract.date = curThis.$root.searchStartDate;
                  curThis.$root.loadContracts();

                } else {
                  curThis.$root.detailsShow = 'ordersummary';
                  curThis.$root.flowString = this.$root.flowString.replace('newstartdate', '');
                }

              }

            });


          }

            // setTimeout(function () {
            //   curThis.$root.searchStartDate = currentDate;
            //   curThis.$root.contract.date = curThis.$root.searchStartDate;
            //   curThis.$root.loadContracts();
            // }, 1000);


        }
      },
      methods: {
      submit() {

        let curThis = this;
        // if (this.$root.contract.date < this.$root.calculateNewContractDate()) {

            if (!this.$root.terms_newstartdate) {
                return false;
            }

            this.$root.terms_newstartdate_text = this.$root.newStartDate_message;
            this.$root.searchStartDate = this.$root.calculateNewContractDate();
            this.$root.contract.date = this.$root.searchStartDate;

            let loadedPriceTypes = [];

            this.$root.loadContracts(function (loadedPriceType) {
              loadedPriceTypes.push(loadedPriceType);

              if (loadedPriceTypes.includes('movable') && loadedPriceTypes.includes('fixed')) {
                //this.$router.push({ name: 'ordersummary' })
                curThis.$root.detailsShow = 'ordersummary';
                curThis.$root.flowString += 'newstartdate';
              }
            });
        // }

      },
    }
  }
  </script>
  <style lang="scss">
    .uppgifter__anlaggning {
      margin-top: 35px;
      &__hidden {
        padding-top: 20px;
      }
      h3 {
        font-size: 18px;
      }
      &__subtitle {
        display: block;
        font-size: 18px;
        font-weight: bold;
      }
      &__field-wrapper {
        position: relative;
        display: block;
        margin-bottom: rem(16);
      }
      &__field-wrapper .info-circle {
        position: absolute;
        top: 60%;
        right: 5%;      
      }    
      &__field {
        position: absolute;
        opacity: 0;
      }
      &__field-content {
        border: 1px solid $light-border-color;
        border-radius: 3px;
        display: block;
      }
      &__field:focus + &__field-content,
      &__field-content:hover {
        border-color: $dark-border-color;
      }
      &__field:checked + &__field-content {
        border-color: $primary-color;
        border-width: 2px;
      }
      &__field-label {
        display: block;
        @include font-primary;
        font-size: rem(16);
        padding: rem(19);
        position: relative;
        em {
          font-style: normal;
          color: #c00;
        }
      }
      .info-circle {
        position: absolute;
        right: 15px;
        bottom: 7px;
        .tooltip {
          display: none;
        }
        &:hover .tooltip {
          display: block;
          left: -360px;
        }
      }
    }
    .customernew {
      &__title {
        text-align: center;
        margin: 0 0 rem(30);
        @include font-primary;
        @include media('>lg') {
          font-size: rem(26);
        }
        @include media('<=lg') {
          font-size: rem(22);
          line-height: (36/22);
        }
      }
      &__block {
        margin-bottom: rem(40);
      }
      &__block-title {
        @include font-primary(bold);
        color: $secondary-text-color;
        font-size: rem(18);
        margin: 0 0 rem(15);
      }
      &__field-wrapper {
        margin-bottom: rem(24);
        font-size: rem(16);
        display: block;
        position: relative;
      }
  
      &__field-group {
        @include media('>lg') {
          display: flex;
          flex-wrap: wrap;
          /*justify-content: space-between;*/
          justify-content: normal;
          align-items: flex-end;
        }
      }
      &__lookup {
          display: flex;
          flex-wrap: wrap;
          /*justify-content: space-between;*/
          justify-content: normal;
          align-items: flex-end;
          .feedback {
              margin-top: -15px;
              margin-bottom: 20px;
          }
      }
      &__field-group &__field-wrapper {
        @include media('>lg') {
          flex-basis: calc(49% - #{rem(12)});
          margin-right: #{rem(12)};
        }
      }
      &__lookup &__field-wrapper {
        flex-basis: calc(49% - #{rem(12)});
      }
      &__field-group &__field-wrapper-third {
        @include media('>lg') {
          flex-basis: calc(24% - #{rem(12)}) !important;
          margin-right: #{rem(12)};
        }
      }
      &__field {
        @include unstyled-text-field;
        display: block;
        width: 100%;
        border: 1px solid $light-border-color;
        padding: #{(13/18)}em;
        &:focus,
        &:hover {
          border-color: $dark-border-color;
        }
        &::placeholder {
          color: $dark-border-color;
        }
      }
      &__field-label {
        @include font-primary;
        color: $secondary-text-color;
        margin: 0 0 rem(6);
        display: block;
        &--title {
          @include font-primary(bold);
          color: $secondary-text-color;
          font-size: rem(18);
          display: block;
          margin: 0 0 rem(9);
        }
        em {
          font-style: normal;
          color: #c00;
        }
      }
      &__lookup-submit {
        @include media('>lg') {
          flex: 1 1;
          margin: 0 0 rem(24) rem(24);
        }
        @include media('<=lg') {
          /*flex: 1 1;*/
          margin: 0 0 rem(24) 0;
        }
        font-size: rem(16);
        &[disabled], &:hover[disabled]{
          background-color: #fff;
        }
        .customernew__submit_text {
          display: block;
        }
        .customernew__submit_loader {
          display: none;
        }
        &.loading {
          padding: 9px 0 6px 0;
          .customernew__submit_text {
            display: none;
          }
          .customernew__submit_loader {
            display: block;
          }
        }
      }
      &__ids {
        margin-bottom: 1rem;
      }
      &__ids-text {
        @include font-primary(roman);
        font-size: rem(13);
        padding: rem(16);
        background-color: $light-bg-color;
        color: $secondary-text-color;
        text-align: center;
        border-radius: 4px;
        display: block;
        width: 100%;
        margin: 25px 0 10px 0;
      }
    }
  
  </style>